import React from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Paper,
  Button,
} from '@material-ui/core';
import Notification from './Notification';
import ServerTitle from './ServerTitle';
import IPButton from '../layout/IPButton';
import DiscordButton from '../layout/DiscordButton';

const style = {
  subPromotion: {
    padding: '16px',
  },
};

function HomeFeatured() {
  return (
    <div className="features" style={{ border: '0px solid red' }}>
      <div className="promotion" style={{ border: '0px solid black' }}>
        <ServerTitle />
        <div className="action">
          <div className="ip">
            <IPButton />
          </div>
          <DiscordButton />
          <Notification />
        </div>
      </div>
      <div className="sub-promotion">
        <Grid container justify="center">
          <Grid xs={12} sm={12} md={4} item>
            <Paper id="games" className="sub-promotion-item" style={style.subPromotion} square>
              <h2>Des Jeux Funs</h2>
              <p>
                PVP Faction, Mini-jeux, RPG, Vivez des expériences de jeu epic !
              </p>
              <img
                src="./game-icon.png"
                alt="Jeux Minecraft"
                className="sub-promotion-icon"
              />
            </Paper>
          </Grid>
          <Grid xs={12} sm={6} md={4} item>
            <Paper id="community" className="sub-promotion-item" style={style.subPromotion} square>
              <h2>Une Communauté Active</h2>
              <p>
                Détendez-vous avec vos amis sur un serveur fiable !
              </p>
              <img
                src="./community-icon.png"
                alt="Communauté Minecraft"
                className="sub-promotion-icon"
              />
            </Paper>
          </Grid>
          <Grid xs={12} sm={6} md={4} item>
            <Paper id="events" className="sub-promotion-item" style={style.subPromotion} square>
              <h2>Des Animations Quotidiennes</h2>
              <p>
                Participez aux nombreux Events et gagnez des cadeaux !
              </p>
              <img
                src="./event-icon.png"
                alt="Event Minecraft"
                className="sub-promotion-icon"
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default HomeFeatured;



// WEBPACK FOOTER //
// ./src/home/HomeFeatured.js